import type { InventoryRecipeSummaryCounts } from '@/renderer/types/inventory';

export function RecipesSummaryCards({
  summary,
}: {
  summary: InventoryRecipeSummaryCounts;
}) {
  const cards = [
    { label: 'Total recipes', value: summary.totalRecipes },
    { label: 'Active', value: summary.activeRecipes },
    { label: 'Inactive', value: summary.inactiveRecipes },
    { label: 'Linked menu items', value: summary.linkedMenuItems },
  ];

  return (
    <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
      {cards.map((card) => (
        <div
          key={card.label}
          className="rounded-2xl border border-gray-200 bg-white px-4 py-4 shadow-sm"
        >
          <p className="text-sm text-gray-500">{card.label}</p>
          <p className="mt-2 text-2xl font-semibold text-gray-900">
            {card.value.toLocaleString()}
          </p>
        </div>
      ))}
    </div>
  );
}
